import { getAuthorizationProperties } from "./authorizationHelper";
import { IParameterAnswer } from "../models/parameterAnswer";

export async function getParameterAnswer(guid: string): Promise<IParameterAnswer> {
    const data = await fetch(`/api/parameters/answer/${guid}`, {
        method: "GET",
        ...getAuthorizationProperties({
            "Content-Type": "application/json",
        }),
    }).then(res => {
        return res.json();
    });
    return data;
}

export async function getParameterAnswers(parameterGuid: string): Promise<IParameterAnswer[]> {
    const params = new URLSearchParams();
    params.append("parameterGuid", parameterGuid);

    const data = await fetch(`/api/parameters/answers?${params.toString()}`, {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    }).then(res => {
        return res.json();
    });
    return data;
}

export const getSummaryAnswers = async (
    parameterGuid: string,
    selectedCountryName: string
): Promise<IParameterAnswer[]> => {
    const params = new URLSearchParams();
    params.append("parameterGuid", parameterGuid);
    params.append("countryName", selectedCountryName);
    const data = await fetch(`/api/parameters/summaryAnswers?${params.toString()}`, {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    }).then(res => {
        return res.json();
    });
    return data;
};

export async function updateAnswerValue(answer: IParameterAnswer): Promise<IParameterAnswer> {
    const data = await fetch(`/api/parameters/answer`, {
        method: "PATCH",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
        body: JSON.stringify(answer),
    }).then(res => {
        return res.json();
    });
    return data;
}

export async function forceAnswerValue(
    answerGuid: string,
    answerValue: number
): Promise<IParameterAnswer> {
    const params = new URLSearchParams();
    params.append("answerGuid", answerGuid);
    params.append("answerValue", answerValue.toString());
    const data = await fetch(`/api/parameters/answer/force?${params.toString()}`, {
        method: "PATCH",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    }).then(res => {
        return res.json();
    });
    return data;
}
